import { axiosInstance } from './axios-instance';

export interface DurationDiscount {
  months: number;
  discount_percent: number;
}

export interface PricingInfo {
  price_per_seat_per_month: number;
  currency: string;
  discounts: DurationDiscount[];
}

export interface SubscriptionStatus {
  has_subscription: boolean;
  subscription: {
    id: number;
    seats: number;
    months: number;
    status: string;
    starts_at: string;
    ends_at: string;
    total_amount: number;
    currency: string;
  } | null;
}

export interface InitiateResult {
  checkout_url: string;
  tx_ref: string;
  total_amount: number;
  currency: string;
  discount_percent: number;
  seats: number;
  months: number;
}

export const subscriptionApi = {
  getPricingInfo: (): Promise<{ success: boolean; data: PricingInfo }> =>
    axiosInstance.get('/subscriptions/pricing-info').then((r) => r.data),

  getStatus: (): Promise<{ success: boolean; data: SubscriptionStatus }> =>
    axiosInstance.get('/subscriptions/status').then((r) => r.data),

  initiate: (
    seats: number,
    months: number
  ): Promise<{ success: boolean; data: InitiateResult }> =>
    axiosInstance
      .post('/subscriptions/initiate', { seats, months })
      .then((r) => r.data),

  verify: (txRef: string): Promise<{ success: boolean }> =>
    axiosInstance
      .post('/subscriptions/verify', { tx_ref: txRef })
      .then((r) => r.data),
};
